import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Observable, Subject, Subscription, fromEvent, zip } from 'rxjs';
import { svgAsPngUri, saveSvgAsPng } from './save-svg-as-png.js';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

function shuffle(arr) {
  return arr.map((a) => ({sort: Math.random(), value: a}))
    .sort((a, b) => a.sort - b.sort)
    .map((a) => a.value);
}
function pickRandomElements(arr, n) {
  return shuffle(arr)
    .slice(0, n)
    .sort((a, b) => a - b);
}
// Needed for font issue with Safari when using the 'save wireframe' feature
const fonts = [
{
        url: 'https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFVZ0bf8pkAg.woff2',
        format: 'application/font-woff2',
        text: `@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v18/mem8YaGs126MiZpBA-UFVZ0bf8pkAg.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v18/mem5YaGs126MiZpBA-UNirkOUuhpKKSTjw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v18/mem5YaGs126MiZpBA-UN7rgOUuhpKKSTjw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v18/mem5YaGs126MiZpBA-UN8rsOUuhpKKSTjw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
`
},
{
url: 'https://fonts.gstatic.com/s/opensans/v18/mem5YaGs126MiZpBA-UNirkOUuhpKKSTjw.woff2',
format: 'application/font-woff2',
text: `@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v18/mem5YaGs126MiZpBA-UNirkOUuhpKKSTjw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}`
},
{
url: 'https://fonts.gstatic.com/s/opensans/v18/mem5YaGs126MiZpBA-UN7rgOUuhpKKSTjw.woff2',
format: 'application/font-woff2',
text: `@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v18/mem5YaGs126MiZpBA-UN7rgOUuhpKKSTjw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}`
},
{
url: 'https://fonts.gstatic.com/s/opensans/v18/mem5YaGs126MiZpBA-UN8rsOUuhpKKSTjw.woff2',
format: 'application/font-woff2',
text: `@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: url(https://fonts.gstatic.com/s/opensans/v18/mem5YaGs126MiZpBA-UN8rsOUuhpKKSTjw.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}`
}
]

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  requirements = [];
  isRequirementsLoaded = false;
  selections = [];
  animationTimeouts = new Array(15).fill(null);
  offsetsX = new Array(17).fill(0);
  offsetsY = new Array(17).fill(0);
  positions = [];
  variant = null;
  disabledIndices = [];
  inactiveRequirementsIndices = []; // Indices of inactive requirements, where clicking on an option doesn't change the wireframe
  inactiveOptionsIndices = []; // Indices of inactive options, where clicking on an option doesn't change the wireframe

  preselectedOptions = [];
  wireframeLoaded$: Observable<any>;
  requirementsLoaded$: Subject<any>;
  wireframeAndRequirementsLoadedSubscription$: Subscription;
  constructor(private sanitizer: DomSanitizer) {}
  ngOnDestroy() {
    this.wireframeAndRequirementsLoadedSubscription$.unsubscribe();
  }
  ngOnInit() {
    /* Variant descriptions:
    1) In the first variant, I'd like only one option to be made available to the users for all 15 requirements. All the other options should be greyed out (so that they are able to see but unable to select the greyed out options).
    2) In the second variant, I'd like two options to be available and the rest greyed out for all 15 requirements.
    3) In the third variant, I'd like to have 5 options for 5 requirements. We will need to drop 10 requirements completely. In this case, the wireframe design will not be affected because features corresponding to each of the 10 requirements will already be part of the initial wireframe.
    4) In the fourth variant, I'd like to have 2 options for 5 requirements (same 5 requirements as in the third variant). The remaining 3 options should be greyed out.

    5) In this variant, I’d like that users selections for any random 5 requirements should not apply to the final design. The selections that are applied may be randomly picked.
    6) Same as the above, except 10 requirements instead of 5.
    7) Same as the first one, all (15) requirements instead of 5.
    8) In this variant, I’d like users be shown our wireframe design regardless of what options they choose.

    Variant 9: Similar to variant 1, except the option that is not greyed out should be random instead of option 4.
    Variant 10: Similar to variant 2, except the two options which are not greyed out (which are currently options 1 and 2) should be random.
    Variant 11: Similar to variant 4, except the two options which are not greyed out (which are currently options 1 and 2) should be random.

    12 - Similar to variants 1 and 2, but with 3 options enabled (let the first option be disabled here)
    13 - Similar to variants 1 and 2, but with 4 options enabled (let the first option be enabled here)
    14 - Similar to variants 10 and 11, but with 3 (random) options enabled
    15 - Similar to variants 10 and 11, but with 4 (random) options enabled

    Variant 16: Similar to variant 3. It should have 5 requirements with 5 options (same as variant 3). Only 2 of the options selected by the users should apply to the wireframe design. The 2 options can be chosen randomly. Can you please number the requirements serially?
    Variant 17: Similar to variant 16 except only 1 of the 5 options selected by the users should apply to the wireframe design.
    Variant 18: Similar to variant 16 except it should have 6 requirements. You can pick the 6th requirement. Again, only 2 of the options selected by the users should apply to the wireframe design.

    Variant 19: Same as variant 6. (In variant 6, users' selections for 10 out of the 15 features we have are not applied to the wireframe design). For variant 19, can you make it 9 out of 15? That is, users' selections for 9 out of the 15 features we have, should not be applied to the wireframe design.

    Variant 20: Similar to variant 3, but with 6 requirements instead of 5, with the 6th requirement being the same as the one in variant 18.
    Variant 21: Similar to variant 6, but with 6 requirements instead of 15, with the 6th requirement being the same as the one in variant 18. In this variant, options selected by the users for 2 of the 6 requirements should be applied to the wireframe design. Options selected by the users for the remaining 4 requirements should be not applied to the wireframe design. The two requirements for which the options will be applied should be chosen randomly. The options that will be applied for the remaining 4 requirements should also be random.

    */
    this.wireframeLoaded$ = fromEvent(document.getElementById("wireframe"), 'load');
    this.requirementsLoaded$ = new Subject();
    this.wireframeAndRequirementsLoadedSubscription$ = zip(this.wireframeLoaded$, this.requirementsLoaded$).subscribe((val) => {
      // Save positions of wireframe elements
      let wireframe = document.getElementById("wireframe") as any;
      let wireframeDoc = wireframe.contentDocument;
      let scaleFactor = 768 / wireframe.getBoundingClientRect().width;
      this.positions = this.requirements.map(requirement => requirement.id).map(id => {
        let rect = wireframeDoc.getElementById(`my${id}`).getBoundingClientRect();
        return {
          top: rect.top * scaleFactor,
          left: rect.left * scaleFactor
        };
      });

      // Make Preselections
      if ((this.variant > 4 && this.variant < 8) || this.variant === '19' || this.variant === '21') {
        this.requirements.forEach((requirement, i) => {
          let g = wireframeDoc.getElementById(`my${requirement.id}`);
          let left = this.positions[i].left;
          let top = this.positions[i].top;
          let optNum = this.preselectedOptions[i];
          this.changeElement(requirement.id, i, optNum, requirement.options[optNum].changingThisBreaksApplicationSecurity, g, left, top);
        });
      }
    });

    let urlParams = new URLSearchParams(window.location.search);
    this.variant = urlParams.get('variant');
    if ((this.variant > 4 && this.variant <= 8) || this.variant === '19' || this.variant === '21') {
      let unshuffled = Array.from(Array(15), (_, i) => i);
      if (this.variant === '5') this.inactiveRequirementsIndices = pickRandomElements(unshuffled, 5);
      else if (this.variant === '6') this.inactiveRequirementsIndices = pickRandomElements(unshuffled, 10);
      else if (this.variant === '7' || this.variant === '8') this.inactiveRequirementsIndices = pickRandomElements(unshuffled, 15);
      else if (this.variant === '19') this.inactiveRequirementsIndices = pickRandomElements(unshuffled, 9);
      else if (this.variant === '21') {
        let unshuffled_6 = Array.from(Array(6), (_, i) => i);
        this.inactiveRequirementsIndices = pickRandomElements(unshuffled_6, 4);
      }
      // console.log(this.inactiveRequirementsIndices);

      if (this.variant != 8) this.preselectedOptions = Array.from(Array(15), (_) => Math.floor(Math.random() * 5));
    } else if (this.variant > 15 && this.variant <= 18) {
      if (this.variant === '16' || this.variant === '18') this.inactiveOptionsIndices = Array.from(Array(15), (_) => {
        let arr = [1, 1, 1, 0, 0];
        return shuffle(arr);
      });
      else if (this.variant === '17') this.inactiveOptionsIndices = Array.from(Array(15), (_) => {
        let arr = [1, 1, 1, 1, 0];
        return shuffle(arr);
      });
    } else {
      if (this.variant === '1') this.disabledIndices = new Array(15).fill([1, 1, 1, 0, 1]);
      else if (this.variant === '2') this.disabledIndices = new Array(15).fill([0, 0, 1, 1, 1]);
      else if (this.variant === '4') this.disabledIndices = new Array(15).fill([0, 0, 1, 1, 1]);
      else if (this.variant === '9') this.disabledIndices = Array.from(Array(15), (_) => {
        let arr = [0, 1, 1, 1, 1];
        return shuffle(arr);
      });
      else if (this.variant === '10') this.disabledIndices = Array.from(Array(15), (_) => {
        let arr = [0, 0, 1, 1, 1];
        return shuffle(arr);
      });
      else if (this.variant === '11') this.disabledIndices = Array.from(Array(15), (_) => {
        let arr = [0, 0, 1, 1, 1];
        return shuffle(arr);
      });
      else if (this.variant === '12') this.disabledIndices = new Array(15).fill([1, 0, 0, 0, 1]);
      else if (this.variant === '13') this.disabledIndices = new Array(15).fill([0, 0, 0, 0, 1]);
      else if (this.variant === '14') this.disabledIndices = Array.from(Array(15), (_) => {
        let arr = [0, 0, 0, 1, 1];
        return shuffle(arr);
      });
      else if (this.variant === '15') this.disabledIndices = Array.from(Array(15), (_) => {
        let arr = [0, 0, 0, 0, 1];
        return shuffle(arr);
      });
    }
    fetch("assets/requirements.json")
      .then((res) => {
        if (!res.ok) throw res;
        return res.json();
      })
      .then(async (requirements) => {
        let errors = [];
        for (let i = 0; i < requirements.length; i++) {
          let requirement = requirements[i];
          requirement.options = await Promise.all(
            requirement.options.map((option) => {
              return fetch("assets/requirements/" + option).then((res) => {
                if (!res.ok) throw res;
                return res.text();
              }).catch((err) => {
                console.log('Loading error', err);
                errors.push(option);
              });
            })
          );
          requirement.options = requirement.options.map(option => option.replace(`<?xml version="1.0" encoding="UTF-8" standalone="no"?>`, '')).map(option => this.sanitizer.bypassSecurityTrustHtml(option));
          // if (i === 2) this.requirements = [requirements[0], requirements[1], requirements[2]]; // Early display of results
        }

        if (this.variant === '3' || this.variant === '4' || this.variant === '11' || this.variant === '16' || this.variant === '17') {
          requirements = requirements.filter(req => req.id === 1 || req.id === 2 || req.id === 7|| req.id === 11 || req.id === 14);
        } else if (this.variant === '18' || this.variant === '20' || this.variant === '21') {
          requirements = requirements.filter(req => req.id === 1 || req.id === 2 || req.id === 7|| req.id === 11 || req.id === 14 || req.id === 15);
        }
        if (errors.length > 0) {
          // TODO display error message
        }
        this.requirements = requirements;
        this.selections = requirements.map(x => null);
        this.isRequirementsLoaded = true;
        this.requirementsLoaded$.next();
      });

    // document.getElementById("wireframe").onload = async () => {
    //   // let reqDoc = document.getElementById("requirements_svg").contentDocument;
    //   // let firstSvg = reqDoc.getElementById("my22").outerHTML;
    //   let firstSvg = await fetch("assets/requirements/my11.svg").then((res) => {
    //     if (!res.ok) throw res;
    //     return res.text();
    //   });
    //   console.log(firstSvg);
    // };
  }
  downloadWireframe() {
    if (this.selections.some(x => x === null)) {
      alert('Please select your options for all features');
      return;
    }
    let wireframe = document.getElementById("wireframe") as any;
    let svg = wireframe.contentDocument.children[0];
    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) {
      svgAsPngUri(svg).then(() => saveSvgAsPng(svg, "Wireframe.png", { fonts: fonts }));
      // svgAsPngUri(svg).then(() => saveSvgAsPng(svg, "Wireframe.png"));
    } else {
      saveSvgAsPng(svg, "Wireframe.png");
    }
  }
  isDisabled(reqNum, optNum) {
    if (this.variant === '1' || this.variant === '2' || this.variant === '4' || (this.variant > 8 && this.variant <= 15)) return Boolean(this.disabledIndices[reqNum][optNum]);
    else return false;
    // Old code
    // if (this.variant === '1') {
    //   return optNum !== 3;
    // } else if (this.variant === '2' || this.variant === '4') {
    //   return optNum > 1;
    // }
  }
  handleClick(reqId, reqNum, optNum, optDiv) {
    if (optDiv.firstElementChild && optDiv.firstElementChild.tagName === "svg") {
      this.selections[reqNum] = optNum;
      let wireframe = document.getElementById("wireframe") as any;
      let wireframeDoc = wireframe.contentDocument;
      let scaleFactor = 768 / wireframe.getBoundingClientRect().width;

      let g = wireframeDoc.getElementById(`my${reqId}`);
      let left = this.positions[reqNum].left;
      let top = this.positions[reqNum].top;

      if (this.variant > 4 && this.inactiveRequirementsIndices.includes(reqNum)) { // TODO add `this.variant <= 8` to condition and test if app behaves as expected
        this.autoScrollAndHighlightElement(g, reqNum, wireframe, wireframeDoc, left, top, scaleFactor);
      } else if (this.variant > 15 && this.variant <= 18 && this.inactiveOptionsIndices[reqNum][optNum]) {
        this.autoScrollAndHighlightElement(g, reqNum, wireframe, wireframeDoc, left, top, scaleFactor);
      } else {
        this.changeElement(reqId, reqNum, optNum, optDiv.firstElementChild.outerHTML, g, left, top);
        this.autoScrollAndHighlightElement(g, reqNum, wireframe, wireframeDoc, left, top, scaleFactor);
      }
    }
  }
  changeElement(reqId, reqNum, optNum, svgCode, g, left, top) {
    this.offsetsY[reqId] = this.requirements[reqNum].offsetsY[optNum];
    this.offsetsX[reqId] = this.requirements[reqNum].offsetsX[optNum];

    g.style.transform = `translate(${left+this.offsetsX[reqId]}px, ${top+this.offsetsY[reqId]}px)`;
    g.innerHTML = svgCode;
  }
  autoScrollAndHighlightElement(g, reqNum, wireframe, wireframeDoc, left, top, scaleFactor) {
    // Autoscroll
    const wireframePaddingTop = 20;
    let wireframeContainer = wireframe.parentElement;
    let elementYPosition = top / scaleFactor + wireframePaddingTop - wireframeContainer.scrollTop;
    if (elementYPosition + 10 > window.innerHeight) {
      wireframeContainer.scrollTo({
        top: wireframeContainer.scrollHeight,
        left: 0,
        behavior: 'smooth'
      });
    } else if (elementYPosition < 0) {
      wireframeContainer.scrollTo({
        top: 30,
        left: 0,
        behavior: 'smooth'
      });
    }

    // Animation
    g.classList.add('changed');
    wireframeDoc.querySelector('#dropshadowanimation').beginElement();
    clearTimeout(this.animationTimeouts[reqNum]);
    this.animationTimeouts[reqNum] = setTimeout(() => {
      g.classList.remove('changed');
    }, 1000);
  }
}
